
import item from "./features/item.features"
import supplier from "./features/supplier.features"
import stock from "./features/stock.features"
import purchase from "./features/purchase.features"
import accounts from "./features/accounts.features"
import company from "./features/company.features"
import customer from "./features/customer.features"
import brand from "./features/brand.features"
import units from "./features/units.features"
import transactions from "./features/transactions.features"
import employee from "./features/employee.features"
import payments from "./features/payments.features"
import barcodesTemplate from "./features/barcode.features"
import user from "./features/user.features"
import shift from "./features/shift.features"
import pos from "./features/pos.features"
import sales from "./features/sales.features"
import permission from "./features/permission.features"
import auth from "./features/auth.features"
import roleReducer from "./features/role.features"
import ticketReducer from "./features/ticket.features"
import phoneModelReducer from "./features/phoneModels.features"
import serviceItemReducer from "./features/serviceItem.features"
import barcodeSettingsReducer from './features/barcodeSettings.features';
import devicesReducer from './features/devices.features';
import deviceInspectionsReducer from './features/deviceInspections.features';
import reportedIssuesReducer from './features/reportedIssues.features';
import serializedStockReducer from './features/serializedStock.features';
import purchaseReturnReducer from './features/purchaseReturn.features';
import expensesReducer from './features/expenses.features';
import rfqReducer from './features/rfq.features';


import { combineReducers } from "redux"


const rootReducer = combineReducers({
    dashboardV2Reducer: require('./features/dashboard.slice').default,
    itemsReducer: item,
    supplierReducer: supplier,
    stockReducer: stock,
    purchaseReducer: purchase,
    accountsReducer: accounts,
    companyReducer: company,
    customersReducer: customer,
    brandsReducer: brand,
    unitsReducer: units,
    transactionsReducer: transactions,
    employeeReducer: employee,
    paymentsReducer: payments,
    barcodesTemplateReducer: barcodesTemplate,
    usersReducer: user,
    shiftReducer: shift,
    salesReducer: sales,
    permissionReducer: permission,
    authReducer: auth,
    roleReducer: roleReducer,
    ticketReducer,
    phoneModelReducer,
    serviceItemReducer,
    barcodeSettingsReducer,
    devicesReducer,
    deviceInspectionsReducer,
    reportedIssuesReducer,
    serializedStockReducer,
    purchaseReturnReducer,
    expensesReducer,
    rfqReducer,
    posReducer: pos
})

export default rootReducer